import React from "react"

import "../styles/index.scss"

import myPrilePic from "../images/Profile1.jpg"
import SEO from "../components/Features/seo"
import Header from "../components/core/header"
import Footer from "../components/core/footer"
import P0 from "../images/portfolio/p0.png"
import P1 from "../images/portfolio/p1.jpg"
import P2 from "../images/portfolio/p2.jpg"
import P3 from "../images/portfolio/p3.jpg"
import P4 from "../images/portfolio/p4.jpg"
import P5 from "../images/portfolio/p5.jpg"
import P6 from "../images/portfolio/p6.jpg"
import P7 from "../images/portfolio/p7.jpg"
import P8 from "../images/portfolio/p8.jpg"
import P9 from "../images/portfolio/p9.jpg"
import P10 from "../images/portfolio/p10.jpg"
import P11 from "../images/portfolio/p11.jpg"
import P12 from "../images/portfolio/p12.png"

import pi0 from "../images/portfolio/pi0.png"
import pi1 from "../images/portfolio/pi1.png"
import pi2 from "../images/portfolio/pi2.png"
import pi3 from "../images/portfolio/pi3.png"
import pi4 from "../images/portfolio/pi4.png"
import pi5 from "../images/portfolio/pi5.png"
import pi6 from "../images/portfolio/pi6.png"
import pi07 from "../images/portfolio/pi07.png"
import pi8 from "../images/portfolio/pi8.png"
import pi9 from "../images/portfolio/pi9.png"


export default function hireMe() {
  return (
    <div>
      <Header />
      <SEO title="Hire Me | Shahid Ali" slug="hire-me" />
      <div className="hireMe">
        <div className="col-lg-3 col-sm-12 p-0 m-0 bg-white">
          <div class="myCard myPropusalCard text-center w-100 bg-white p-3 myPropusal pb-4">
            <div class=" ">
              <div className="">
                <img
                  class="hireImagefull "
                  src={myPrilePic}
                  alt="Shahid ali CEO of ExtraPixels and Founder of Freelacology"
                />
              </div>
              <div class="card-bodyfull pt-2 pb-0 pl-3 pr-3">
                <h3 class="card-title font-weight-bold text-center mt-0 mb-0">
                  SHAHID ALI
                </h3>
                <h5 className="text-center mt-0 mb-2 text-dark">
                  Software Developer
                </h5>

                <div>
                  <ul className="icons">
                    <li>
                      <a href="mailto:shahidedu696@gmail.com">
                        <i class="fa fa-google" aria-hidden="true"></i>
                      </a>
                    </li>

                    <li>
                      <a href="https://twitter.com/ShahidAli696">
                        <i class="fa fa-twitter" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://github.com/Shahidali696">
                        <i class="fa fa-github" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/in/shahid-ali-653121198/">
                        <i class="fa fa-linkedin" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* <h4 className="text-center">Thanks! Shahid Ali</h4> */}
        </div>
        <div className="col-lg-5 col-sm-12 myPropusal pt-2 ">
          <h1 className="jazz-feed text-left mb-1">
            Thank you for your interest in me{" "}
          </h1>
          <h6>
            Here is Shahid Ali CEO of{" "}
            <a href="http://extrapixels.surge.sh/">ExtraPixels </a>and Fouder of{" "}
            <a href="http://freelancology.com/">Freelancology</a>
          </h6>{" "}
          <p className="text-justify">
            We have team of profesional full-stack web , Mobile APP development,
            cloud Computing also we are offering Digital Marketing Services like
            SEO, SMM, PPC, Email Marketing and Graphic Designing services. We
            have been working on website and application development from the
            past 5 years, we have worked on many projects. if our expertise
            matches with your project feel free to ping us. we are available for
            your Full Fledged project.
            <h5>Our core expertise & skills are : </h5>
            <h6>
              Web and Mobile Application Development:{" "}
              <small className="text-muted">
                {" "}
                AngularJS, ReactJs,Gatsby, NodeJS, MySQL, MongoDB,
                React-Native/Ionic, WordPress theme & custom WordPress
                development - OpenCart, Shopify, - HTML5, CSS3, JavaScript,
                Jquery, etc. Bonus SEO one-page off-page with Back-links.
              </small>
            </h6>
            <h6>
              Cloud Computing:{" "}
              <small className="text-muted">
                Server management Windows/Linux, Kubernetes, Docker, CICD,
                GithubCompute, storage, database, analytics, networking,
                enterprise applications, etc.
              </small>
            </h6>
            <h6>
              Other Services :{" "}
              <small className="text-muted">
                SEO, SMM, PPC, Email Marketing
                <br />
                Graphics Designing: - Abode illustrator, Photoshop, InDesign,
                Premier Pro, 3D Max etc...
              </small>
            </h6>
          </p>
          <div className="portfolio bg-white p-3 ">
            <h6 className="h6 bold">Take a look at few recent portfolios:</h6>
            <div className="d-flex myScrollH  ">
              <hr />
             
             
              <div className="cardHover">
                <a href="https://hospital.isra.edu.pk/">
                  <img src={pi2} alt="Project of Shahid ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="https://www.isra.edu.pk/">
                  <img src={pi3} alt="Project of Shahid ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="https://moodle.isra.support/">
                  <img src={pi4} alt="Project of Shahid ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="https://ee.isra.edu.pk/">
                  <img src={pi5} alt="Project of Shahid ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="https://alumni.isra.edu.pk/">
                  <img src={pi6} alt="Project of Shahid ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="https://isra.edu.pk/">
                  <img src={pi07} alt="Project of Shahid ali error" />
                </a>
              </div>
              <div className="cardHover">
                <a href="https://qec.isra.edu.pk/">
                  <img src={pi8} alt="Project of Shahid ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="https://oric.isra.edu.pk/">
                  <img src={pi9} alt="Project of Shahid ali" />
                </a>
              </div>

              <div className="cardHover ">
                <a href="http://www.toyota-point.com/">
                  <img src={P1} alt="Project of Shahid Ali" />
                </a>
              </div>
              <div className="cardHover ">
                <a href="https://www.encast.gives/">
                  <img src={P0} alt="Project of Shahid Ali" />
                </a>
              </div>

              <div className="cardHover">
                <a href="http://www.mysehwan.com/">
                  <img src={P2} alt="Project of Shahid Ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="https://isra.edu.pk/">
                  <img src={pi0} alt="Project of Shahid ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="http://www.iess.pk/">
                  <img src={P3} alt="Project of Shahid Ali" />
                </a>
              </div>

              <div className="cardHover">
                <a href="https://play.google.com/store/apps/details?id=com.sagheer.triroidsonlineshoppingapp&hl=en">
                  <img src={P4} alt="Project of Shahid Ali" />
                </a>
              </div>

              <div className="cardHover">
                <a href="https://play.google.com/store/apps/details?id=com.sagheer.triroidsonlineshoppingapp&hl=en">
                  <img src={P5} alt="Project of Shahid Ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="https://isra.edu.pk">
                  <img src={pi1} alt="Project of Shahid ali" />
                </a>
              </div>

              <div className="cardHover">
                <a href="https://play.google.com/store/apps/details?id=com.xcl.bites&hl=en">
                  <img src={P6} alt="Project of Shahid Ali" />
                </a>
              </div>

              <div className="cardHover">
                <a href="http://www.dawoodonline.pk/">
                  <img src={P7} alt="Project of Shahid Ali" />
                </a>
              </div>

              <div className="cardHover">
                <a href="https://shamsicon.com/">
                  <img src={P8} alt="Project of Shahid Ali" />
                </a>
              </div>

              <div className="cardHover">
                <a href="http://sbd.com.pk/">
                  <img src={P9} alt="Project of Shahid Ali" />
                </a>
              </div>

              <div className="cardHover">
                <a href="https://whitepearlgroup.com/">
                  <img src={P10} alt="Project of Shahid Ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="http://www.freelancology.com/">
                  <img src={P11} alt="Project of Shahid Ali" />
                </a>
              </div>
              <div className="cardHover">
                <a href="http://almaalikbuilders.com/">
                  <img src={P12} alt="Project of Shahid Ali" />
                </a>
              </div>
            </div>
          </div>
          <h5 className="">
            Our main focus is to earn client trust and build a long term
            relationship by providing premium quality services.
          </h5>
        </div>
        {/* <div className="col-lg-3 col-sm-12 "></div> */}
        <div className="bg-white col-lg-4 col-sm-12 pt-5 ">
          <form
            action="https://getform.io/f/9b5c5cb8-81d5-4fd2-b599-a50ba210eed4"
            method="POST"
          >
            <div class="form-row">
              <div class="form-group col-md-12">
                <h5 className="heading text-center">Get in Touch Quick</h5>
                <div class="form-group col-md-12">
                  <input
                    name="name"
                    type="text"
                    class="form-control"
                    id="inputName"
                    placeholder="Name"
                  />
                </div>
                <div class="form-group col-md-12">
                  <input
                    name="email"
                    type="email"
                    class="form-control"
                    id="inputEmail4"
                    placeholder="Email"
                  />
                </div>
                <div class="form-group col-md-12">
                  <input
                    name="phone"
                    type="text"
                    class="form-control"
                    id="inputPhone"
                    placeholder="Contact No#"
                  />
                </div>
                <div class="form-group col-md-12">
                  <select
                    id="country"
                    name="country"
                    class="form-control mt-3"
                    placeholder="Select Country"
                  >
                    <option value="Afghanistan">Afghanistan</option>
                    <option value="Åland Islands">Åland Islands</option>
                    <option value="Albania">Albania</option>
                    <option value="Algeria">Algeria</option>
                    <option value="American Samoa">American Samoa</option>
                    <option value="Andorra">Andorra</option>
                    <option value="Angola">Angola</option>
                    <option value="Anguilla">Anguilla</option>
                    <option value="Antarctica">Antarctica</option>
                    <option value="Antigua and Barbuda">
                      Antigua and Barbuda
                    </option>
                    <option value="Argentina">Argentina</option>
                    <option value="Armenia">Armenia</option>
                    <option value="Aruba">Aruba</option>
                    <option value="Australia">Australia</option>
                    <option value="Austria">Austria</option>
                    <option value="Azerbaijan">Azerbaijan</option>
                    <option value="Bahamas">Bahamas</option>
                    <option value="Bahrain">Bahrain</option>
                    <option value="Bangladesh">Bangladesh</option>
                    <option value="Barbados">Barbados</option>
                    <option value="Belarus">Belarus</option>
                    <option value="Belgium">Belgium</option>
                    <option value="Belize">Belize</option>
                    <option value="Benin">Benin</option>
                    <option value="Bermuda">Bermuda</option>
                    <option value="Bhutan">Bhutan</option>
                    <option value="Bolivia">Bolivia</option>
                    <option value="Bosnia and Herzegovina">
                      Bosnia and Herzegovina
                    </option>
                    <option value="Botswana">Botswana</option>
                    <option value="Bouvet Island">Bouvet Island</option>
                    <option value="Brazil">Brazil</option>
                    <option value="British Indian Ocean Territory">
                      British Indian Ocean Territory
                    </option>
                    <option value="Brunei Darussalam">Brunei Darussalam</option>
                    <option value="Bulgaria">Bulgaria</option>
                    <option value="Burkina Faso">Burkina Faso</option>
                    <option value="Burundi">Burundi</option>
                    <option value="Cambodia">Cambodia</option>
                    <option value="Cameroon">Cameroon</option>
                    <option value="Canada">Canada</option>
                    <option value="Cape Verde">Cape Verde</option>
                    <option value="Cayman Islands">Cayman Islands</option>
                    <option value="Central African Republic">
                      Central African Republic
                    </option>
                    <option value="Chad">Chad</option>
                    <option value="Chile">Chile</option>
                    <option value="China">China</option>
                    <option value="Christmas Island">Christmas Island</option>
                    <option value="Cocos (Keeling) Islands">
                      Cocos (Keeling) Islands
                    </option>
                    <option value="Colombia">Colombia</option>
                    <option value="Comoros">Comoros</option>
                    <option value="Congo">Congo</option>
                    <option value="Congo, The Democratic Republic of The">
                      Congo, The Democratic Republic of The
                    </option>
                    <option value="Cook Islands">Cook Islands</option>
                    <option value="Costa Rica">Costa Rica</option>
                    <option value="Cote D'ivoire">Cote D'ivoire</option>
                    <option value="Croatia">Croatia</option>
                    <option value="Cuba">Cuba</option>
                    <option value="Cyprus">Cyprus</option>
                    <option value="Czech Republic">Czech Republic</option>
                    <option value="Denmark">Denmark</option>
                    <option value="Djibouti">Djibouti</option>
                    <option value="Dominica">Dominica</option>
                    <option value="Dominican Republic">
                      Dominican Republic
                    </option>
                    <option value="Ecuador">Ecuador</option>
                    <option value="Egypt">Egypt</option>
                    <option value="El Salvador">El Salvador</option>
                    <option value="Equatorial Guinea">Equatorial Guinea</option>
                    <option value="Eritrea">Eritrea</option>
                    <option value="Estonia">Estonia</option>
                    <option value="Ethiopia">Ethiopia</option>
                    <option value="Falkland Islands (Malvinas)">
                      Falkland Islands (Malvinas)
                    </option>
                    <option value="Faroe Islands">Faroe Islands</option>
                    <option value="Fiji">Fiji</option>
                    <option value="Finland">Finland</option>
                    <option value="France">France</option>
                    <option value="French Guiana">French Guiana</option>
                    <option value="French Polynesia">French Polynesia</option>
                    <option value="French Southern Territories">
                      French Southern Territories
                    </option>
                    <option value="Gabon">Gabon</option>
                    <option value="Gambia">Gambia</option>
                    <option value="Georgia">Georgia</option>
                    <option value="Germany">Germany</option>
                    <option value="Ghana">Ghana</option>
                    <option value="Gibraltar">Gibraltar</option>
                    <option value="Greece">Greece</option>
                    <option value="Greenland">Greenland</option>
                    <option value="Grenada">Grenada</option>
                    <option value="Guadeloupe">Guadeloupe</option>
                    <option value="Guam">Guam</option>
                    <option value="Guatemala">Guatemala</option>
                    <option value="Guernsey">Guernsey</option>
                    <option value="Guinea">Guinea</option>
                    <option value="Guinea-bissau">Guinea-bissau</option>
                    <option value="Guyana">Guyana</option>
                    <option value="Haiti">Haiti</option>
                    <option value="Heard Island and Mcdonald Islands">
                      Heard Island and Mcdonald Islands
                    </option>
                    <option value="Holy See (Vatican City State)">
                      Holy See (Vatican City State)
                    </option>
                    <option value="Honduras">Honduras</option>
                    <option value="Hong Kong">Hong Kong</option>
                    <option value="Hungary">Hungary</option>
                    <option value="Iceland">Iceland</option>
                    <option value="India">India</option>
                    <option value="Indonesia">Indonesia</option>
                    <option value="Iran, Islamic Republic of">
                      Iran, Islamic Republic of
                    </option>
                    <option value="Iraq">Iraq</option>
                    <option value="Ireland">Ireland</option>
                    <option value="Isle of Man">Isle of Man</option>
                    <option value="Israel">Israel</option>
                    <option value="Italy">Italy</option>
                    <option value="Jamaica">Jamaica</option>
                    <option value="Japan">Japan</option>
                    <option value="Jersey">Jersey</option>
                    <option value="Jordan">Jordan</option>
                    <option value="Kazakhstan">Kazakhstan</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Kiribati">Kiribati</option>
                    <option value="Korea, Democratic People's Republic of">
                      Korea, Democratic People's Republic of
                    </option>
                    <option value="Korea, Republic of">
                      Korea, Republic of
                    </option>
                    <option value="Kuwait">Kuwait</option>
                    <option value="Kyrgyzstan">Kyrgyzstan</option>
                    <option value="Lao People's Democratic Republic">
                      Lao People's Democratic Republic
                    </option>
                    <option value="Latvia">Latvia</option>
                    <option value="Lebanon">Lebanon</option>
                    <option value="Lesotho">Lesotho</option>
                    <option value="Liberia">Liberia</option>
                    <option value="Libyan Arab Jamahiriya">
                      Libyan Arab Jamahiriya
                    </option>
                    <option value="Liechtenstein">Liechtenstein</option>
                    <option value="Lithuania">Lithuania</option>
                    <option value="Luxembourg">Luxembourg</option>
                    <option value="Macao">Macao</option>
                    <option value="Macedonia, The Former Yugoslav Republic of">
                      Macedonia, The Former Yugoslav Republic of
                    </option>
                    <option value="Madagascar">Madagascar</option>
                    <option value="Malawi">Malawi</option>
                    <option value="Malaysia">Malaysia</option>
                    <option value="Maldives">Maldives</option>
                    <option value="Mali">Mali</option>
                    <option value="Malta">Malta</option>
                    <option value="Marshall Islands">Marshall Islands</option>
                    <option value="Martinique">Martinique</option>
                    <option value="Mauritania">Mauritania</option>
                    <option value="Mauritius">Mauritius</option>
                    <option value="Mayotte">Mayotte</option>
                    <option value="Mexico">Mexico</option>
                    <option value="Micronesia, Federated States of">
                      Micronesia, Federated States of
                    </option>
                    <option value="Moldova, Republic of">
                      Moldova, Republic of
                    </option>
                    <option value="Monaco">Monaco</option>
                    <option value="Mongolia">Mongolia</option>
                    <option value="Montenegro">Montenegro</option>
                    <option value="Montserrat">Montserrat</option>
                    <option value="Morocco">Morocco</option>
                    <option value="Mozambique">Mozambique</option>
                    <option value="Myanmar">Myanmar</option>
                    <option value="Namibia">Namibia</option>
                    <option value="Nauru">Nauru</option>
                    <option value="Nepal">Nepal</option>
                    <option value="Netherlands">Netherlands</option>
                    <option value="Netherlands Antilles">
                      Netherlands Antilles
                    </option>
                    <option value="New Caledonia">New Caledonia</option>
                    <option value="New Zealand">New Zealand</option>
                    <option value="Nicaragua">Nicaragua</option>
                    <option value="Niger">Niger</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="Niue">Niue</option>
                    <option value="Norfolk Island">Norfolk Island</option>
                    <option value="Northern Mariana Islands">
                      Northern Mariana Islands
                    </option>
                    <option value="Norway">Norway</option>
                    <option value="Oman">Oman</option>
                    <option value="Pakistan">Pakistan</option>
                    <option value="Palau">Palau</option>
                    <option value="Palestinian Territory, Occupied">
                      Palestinian Territory, Occupied
                    </option>
                    <option value="Panama">Panama</option>
                    <option value="Papua New Guinea">Papua New Guinea</option>
                    <option value="Paraguay">Paraguay</option>
                    <option value="Peru">Peru</option>
                    <option value="Philippines">Philippines</option>
                    <option value="Pitcairn">Pitcairn</option>
                    <option value="Poland">Poland</option>
                    <option value="Portugal">Portugal</option>
                    <option value="Puerto Rico">Puerto Rico</option>
                    <option value="Qatar">Qatar</option>
                    <option value="Reunion">Reunion</option>
                    <option value="Romania">Romania</option>
                    <option value="Russian Federation">
                      Russian Federation
                    </option>
                    <option value="Rwanda">Rwanda</option>
                    <option value="Saint Helena">Saint Helena</option>
                    <option value="Saint Kitts and Nevis">
                      Saint Kitts and Nevis
                    </option>
                    <option value="Saint Lucia">Saint Lucia</option>
                    <option value="Saint Pierre and Miquelon">
                      Saint Pierre and Miquelon
                    </option>
                    <option value="Saint Vincent and The Grenadines">
                      Saint Vincent and The Grenadines
                    </option>
                    <option value="Samoa">Samoa</option>
                    <option value="San Marino">San Marino</option>
                    <option value="Sao Tome and Principe">
                      Sao Tome and Principe
                    </option>
                    <option value="Saudi Arabia">Saudi Arabia</option>
                    <option value="Senegal">Senegal</option>
                    <option value="Serbia">Serbia</option>
                    <option value="Seychelles">Seychelles</option>
                    <option value="Sierra Leone">Sierra Leone</option>
                    <option value="Singapore">Singapore</option>
                    <option value="Slovakia">Slovakia</option>
                    <option value="Slovenia">Slovenia</option>
                    <option value="Solomon Islands">Solomon Islands</option>
                    <option value="Somalia">Somalia</option>
                    <option value="South Africa">South Africa</option>
                    <option value="South Georgia and The South Sandwich Islands">
                      South Georgia and The South Sandwich Islands
                    </option>
                    <option value="Spain">Spain</option>
                    <option value="Sri Lanka">Sri Lanka</option>
                    <option value="Sudan">Sudan</option>
                    <option value="Suriname">Suriname</option>
                    <option value="Svalbard and Jan Mayen">
                      Svalbard and Jan Mayen
                    </option>
                    <option value="Swaziland">Swaziland</option>
                    <option value="Sweden">Sweden</option>
                    <option value="Switzerland">Switzerland</option>
                    <option value="Syrian Arab Republic">
                      Syrian Arab Republic
                    </option>
                    <option value="Taiwan, Province of China">
                      Taiwan, Province of China
                    </option>
                    <option value="Tajikistan">Tajikistan</option>
                    <option value="Tanzania, United Republic of">
                      Tanzania, United Republic of
                    </option>
                    <option value="Thailand">Thailand</option>
                    <option value="Timor-leste">Timor-leste</option>
                    <option value="Togo">Togo</option>
                    <option value="Tokelau">Tokelau</option>
                    <option value="Tonga">Tonga</option>
                    <option value="Trinidad and Tobago">
                      Trinidad and Tobago
                    </option>
                    <option value="Tunisia">Tunisia</option>
                    <option value="Turkey">Turkey</option>
                    <option value="Turkmenistan">Turkmenistan</option>
                    <option value="Turks and Caicos Islands">
                      Turks and Caicos Islands
                    </option>
                    <option value="Tuvalu">Tuvalu</option>
                    <option value="Uganda">Uganda</option>
                    <option value="Ukraine">Ukraine</option>
                    <option value="United Arab Emirates">
                      United Arab Emirates
                    </option>
                    <option value="United Kingdom">United Kingdom</option>
                    <option value="United States">United States</option>
                    <option value="United States Minor Outlying Islands">
                      United States Minor Outlying Islands
                    </option>
                    <option value="Uruguay">Uruguay</option>
                    <option value="Uzbekistan">Uzbekistan</option>
                    <option value="Vanuatu">Vanuatu</option>
                    <option value="Venezuela">Venezuela</option>
                    <option value="Viet Nam">Viet Nam</option>
                    <option value="Virgin Islands, British">
                      Virgin Islands, British
                    </option>
                    <option value="Virgin Islands, U.S.">
                      Virgin Islands, U.S.
                    </option>
                    <option value="Wallis and Futuna">Wallis and Futuna</option>
                    <option value="Western Sahara">Western Sahara</option>
                    <option value="Yemen">Yemen</option>
                    <option value="Zambia">Zambia</option>
                    <option value="Zimbabwe">Zimbabwe</option>
                  </select>
                </div>
                <div class="form-group col-md-12">
                  <input
                    name="subject"
                    type="text"
                    class="form-control"
                    id="inputSubject"
                    placeholder="Subejct or Project Heading"
                  />
                </div>
                <div class="form-group col-md-12">
                  <textarea
                    name="message"
                    className="form-control h-100"
                    aria-label="With textarea"
                    placeholder="Your Message or Brief About Project..."
                  ></textarea>
                </div>
                <div class="form-group col-md-12">
                  <button
                    type="submit"
                    class="btn btn-primary w-100 text-center"
                  >
                    Get in Touch Quick
                  </button>
                </div>
              </div>
              <div class="form-group col-md-6"></div>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  )
}
